import axios from './axios.Interceptor';
import environment from 'src/environment/environment';

export class RealSizeViewerService {
	 static baseUrl = environment.apiGateway.realSizeApiUrl + 'GenerateImage/';

	/**
	 *  generate image
	 */
	public static async generateImage(data: any) {
		try {
			const formData = new FormData();
			for(const key in data) {
				formData.append(key, data[key]);
			}
            const url = this.baseUrl;
			const res = await axios.post(url, formData);
			return res;
		} catch (error) {
			throw error;
		}
	}
}
